<template>
	<div class="full" style="overflow: auto;box-sizing: border-box;padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="4">
				<div>
					<el-card shadow="hover" style="width: 100%;">
						<div style="width: 100%; display: inline-block; ">
							<el-statistic>
								<template slot="title">
									<div style="font-size: 14px;text-align: left;color: black;font-weight: bolder;">仓库到货【日】</div>
								</template>
								<template slot="formatter">
									<div style="font-size: 12px;">
										<div style="margin-bottom: 6px;color: gray;">处理数量<span style="font-size: 20px;margin-left: 20px;color: black;">999</span></div>
										<div style="margin-bottom: 6px;color: gray;">处理重量<span style="font-size: 20px;margin-left: 20px;color: black;">999</span></div>
										<div style="margin-bottom: 6px;color: gray;">在途数量<span style="font-size: 20px;margin-left: 20px;color: black;">999</span></div>
										<div style="margin-bottom: 6px;color: gray;">在途重量<span style="font-size: 20px;margin-left: 20px;color: black;">999</span></div>
									</div>
								</template>
							</el-statistic>
						</div>
					</el-card>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<el-card shadow="hover" style="width: 100%;">
						<div style="width: 100%; display: inline-block; ">
							<el-statistic>
								<template slot="title">
									<div style="font-size: 14px;text-align: left;color: black;font-weight: bolder;">发票统计【月】</div>
								</template>
								<template slot="formatter">
									<div style="font-size: 12px;">
										<div style="margin-bottom: 6px;color: gray;">销项数量<span style="font-size: 20px;margin-left: 20px;color: black;">999</span></div>
										<div style="margin-bottom: 6px;color: gray;">销项金额<span style="font-size: 20px;margin-left: 20px;color: black;">999</span></div>
										<div style="margin-bottom: 6px;color: gray;">进项数量<span style="font-size: 20px;margin-left: 20px;color: black;">999</span></div>
										<div style="margin-bottom: 6px;color: gray;">进项金额<span style="font-size: 20px;margin-left: 20px;color: black;">999</span></div>
									</div>
								</template>
							</el-statistic>
						</div>
					</el-card>
				</div>
			</el-col>
		</el-row>

	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		name: 'datacenterIndex',
		props: {

		},
		data() {
			return {
				like: true,
				value1: 4154.564,
				value2: 1314
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {

		}
	}
</script>